module.exports = __webpack_public_path__ + "static/media/vinsmoke-reiju-win.87ace8ef.png";